import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    react: {
      useSuspense: true,   // ← make sure this is true
    },
    resources: {
      en: {
        translations: {
          "General": "General",
          "Dashboards": "Dashboards",
          "Dashboard": "Dashboard",
          "Default": "Default",
          "Ecommerce": "Ecommerce",
          "Receipts": "Receipts",
          "Attendance": "Attendance",
          "Payment Due": "Payment Due",
          "Users": "Users",
          "ncell1": "1. Ncell users dial *9966# and NTC users dial *922#",
          "ncell2": "2. A message with registered name for the number will be displayed",
          "ncell3": "3. Take a sereenshot and upload it here.",
          "Widgets": "Widgets",
          "Firms": "Firms",
          "export as csv": "export as csv",
          "Proxies": "Election Portal",
          "Digital IDs": "Digital IDs",
          "Chart": "Chart",
          " Applications": "Applications",
          "Ready to use Apps": "Ready to use Apps",
          "Firm Updates": "फर्म अपडेटहरू",
          "New update to the firm": "New update to the firm",
          "Welcome, your dashboard is ready!":
            "Welcome, your dashboard is ready!",
          "Firm List": "Firm List",
          "Photo": "Photo",
          "Stamp": "Stamp",
          "NADA Document": "NADA Document",
          "Phone number owner's proof.": "Phone number owner's proof.",
          "ID": "ID",
          "Name": "Name",
          "Pan Number": "Pan Number",
          "Type of Organization": "Type of Organization",
          "Status": "Status",
          "Actions": "Actions",
          "Set Proxy Date": "Set Proxy Date",
          "Add New": "Add New",
          "Proxy List": "Representatives List",
          "Filter by Name": "Filter by Name",
          "Proxy UID": "Proxy UID",
          "Name of Firm": "Name of Firm",
          "Digital Id List": "Digital Id List",
          "Digital UID": "Digital UID",
          "User List": "User List",
          "Phone Number": "Phone Number",
          "Bulk Upload": "Bulk Upload",
          "Filter by Province": "Filter by Province",
          "Filter by District": "Filter by District",
          "Filter by Status": "Filter by Status",
          "Update User Role": "Update User",
          "Close": "Close",
          "Update": "Update",
          "Add Firm": "Add Firm",
          "Type of Firm": "Type of Firm",
          "Contact Person": "Contact Person",
          "Position": "Position",
          "Update Contact Person Passport Photo":
            "Upload a profile picture",
          "Province": "Province",
          "District": "District",
          "City": "City",
          "Address": "Address",
          "Firm Latitude": "Firm Latitude",
          "Firm Longitude": "Firm Longitude",
          "Upload Stamp of firm": "Upload picture of stamp",
          "Upload Suporting Document": "Upload NADA Document",
          "Upload Another Suporting Document":
          "Upload screenshot",
          "New Membership Payment proof": "New Membership Payment proof",
          "No New Membership Payment proof found": "No New Membership Payment proof found",
          "AGM Payment proof": "AGM Payment proof",
          "AGM Status": "AGM Status",
          "New Membership Status": "New Membership Status",
          "Provincial Payment proof": "Provincial Payment proof",
          "Fiscal Years(Membership)": "Fiscal Years(Membership)",
          "Provincial Fees to be paid": "Provincial Fees to be paid",
          "Province Status": "Province Status",
          "Set Current Location": "Set Current Location",
          "Drop A File": "Drop A File",
          "Name is required": "Name is required",
          "Pan Number is required": "Pan Number is required",
          "Position is required": "Position is required",
          "Address is required": "Address is required",
          "Passport Size Photo is required": "Passport Size Photo is required",
          "Stamp Image is required": "Stamp Image is required",
          "Contact Person is required": "Contact Person is required",
          "Phone Number is required": "Incorrect Number",
          "same as logged user?": "same as logged user?",
          "Edit Firm": "Edit Firm",
          "View current Photo": "View current Photo",
          "Update Stamp of firm": "Upload picture of stamp",
          "View current Stamp": "View current Stamp",
          "Update Supporting Document": "Upload NADA Document",
          "View current supporting document": "View current supporting document",
          "Update Another Supporting Document": "Upload screenshot",
          "View current supporting document 2": "View current supporting document 2",
          "Firm Notes": "Firm Notes",
          "Firm Status": "Firm Status",
          "Update Firm": "Update Firm",
          "Current Passport Size Photo": "Current Passport Size Photo",
          "Password": "Password",
          "Update Profile": "Update Profile",
          "User Edit": "User Edit",
          "Bulk Upload Firms": "Bulk Upload Firms",
          "Upload CSV File": "Upload CSV File",
          "Upload": "Upload",
          "Sign In To NADA Admin Portal": "Sign In To NADA Admin Portal",
          "Welcome back! Log in to your account.": "Welcome back! Log in to your account.",
          "Forgot Password": "Forgot Password",
          "Send SMS Reminder": "Send SMS Reminder",
          "Filter By Date": "Filter By Date",
          "Sign In": "Sign In",
          "Don't have account ?": "Don't have account ?",
          "Create Account": "Create Account",
          "Create your account": "Create your account",
          "Already have an account?": "Already have an account?",
          "Continue": "Continue",
          "OTP Code": "OTP Code",
          "Enter 4-digit code": "Enter 4-digit code",
          "Enter your phone number to start": "Enter your phone number to start",
          "Start Date & Time": "Start Date & Time",
          "End Date & Time": "End Date & Time",
          "Set Membership Fees": "Set Membership Fees",
          "New Membership Price": "New Membership Price",
          "Renewal Membership Price": "Renewal Membership Price",
          "Set renew membership price": "Set renew membership price",
          "Set new membership price": "Set new membership price",
          "Verification":  "Verification",
          "Verify Document": "Verify Document",
          "Please scan the qr. If the doc is verified, it will be opened in new tab.": "Please scan the qr. If the doc is verified, it will be opened in new tab.",
          "To Scan another qr, please refresh the page": "To Scan another qr, please refresh the page",
          "Payment Type": "Payment Type",
          "Membership Status": "yearly membership fees",
          "Payment proof": "Payment proof",
          "No Payment proof found": "No Payment proof found",
          "Proxy Status": "Proxy Status"
        },
      },
      es: {
        translations: {
          "General": "General",
          "Dashboards": "ड्यासबोर्डहरू",
          "Dashboard": "ड्यासबोर्ड",
          "Default": "पूर्वनिर्धारित",
          "Ecommerce": "Comercio electrónico",
          "Users": "प्रयोगकर्ताहरू",
          "Firms": "फर्महरू",
          "Proxies": "निर्वाचन पोर्टल",
          "Digital IDs": "डिजिटल आईडी",
          "export as csv": "csv को रूपमा निर्यात गर्नुहोस्",
          "Widgets": "Widgets",
          "Chart": "Gráfico",
          "Applications": "Aplicaciones",
          "Ready to use Apps": "Gereed om programme te gebruik",
          "Firm Updates": "फर्म अपडेटहरू",
          "New update to the firm": "फर्ममा नयाँ अपडेट",
          "Welcome, your dashboard is ready!":
            "स्वागत छ, तपाईंको ड्यासबोर्ड तयार छ!",
          "Firm List": "फर्म सूची",
          "ID": "आईडी",
          "Name": "नाम",
          "Pan Number": "प्यान नम्बर",
          "Type of Organization": "संगठनको प्रकार",
          "Status": "स्थिति",
          "Actions": "कार्यहरू",
          "Filter By Date": "मिति अनुसार फिल्टर गर्नुहोस्",
          "New Membership Payment proof": "नयाँ सदस्यता भुक्तानी प्रमाण",
          "No New Membership Payment proof found": "नयाँ सदस्यता भुक्तानी प्रमाण फेला परेन",
          "AGM Payment proof": "वार्षिक साधारण सभा (AGM) भुक्तानी प्रमाण",
          "AGM Status": "वार्षिक साधारण सभा स्थिति",
          "Send SMS Reminder": "SMS रिमाइन्डर पठाउनुहोस्",
          "New Membership Status": "नयाँ सदस्यता स्थिति",
          "Provincial Payment proof": "प्रदेश भुक्तानी प्रमाण",
          "Fiscal Years(Membership)": "आर्थिक वर्षहरू (सदस्यता)",
          "Provincial Fees to be paid": "तिर्नुपर्ने प्रदेश शुल्क",
          "Province Status": "प्रदेश स्थिति",
          "Add New": "नयाँ थप्नुहोस्",
          "Proxy List": "प्रतिनिधि सूची",
          "Filter by Name": "नाम द्वारा फिल्टर गर्नुहोस्",
          "Proxy UID": "प्रोक्सी UID",
          "Name of Firm": "फर्मको नाम",
          "Digital Id List": "डिजिटल आईडी सूची",
          "Digital UID": "डिजिटल UID",
          "ncell1": "१. एनसेल प्रयोगकर्ताहरूले *९९६६# डायल गर्नुहोस् र एनटीसी प्रयोगकर्ताहरूले *९२२# डायल गर्नुहोस्।",
          "ncell2": "२. नम्बरको लागि दर्ता गरिएको नाम सहितको सन्देश प्रदर्शित हुनेछ।",
          "ncell3": "३. सेरिनसट लिनुहोस् र यहाँ अपलोड गर्नुहोस्।",
          "User List": "प्रयोगकर्ता सूची",
          "Phone Number": "फोन नम्बर",
          "Bulk Upload": "बल्क अपलोड",
          "Filter by Province": "प्रान्त अनुसार फिल्टर गर्नुहोस्",
          "Filter by District": "जिल्ला अनुसार फिल्टर गर्नुहोस्",
          "Filter by Status": "स्थिति अनुसार फिल्टर गर्नुहोस्",
          "Update User Role": "प्रयोगकर्ता अपडेट गर्नुहोस्",
          "Close": "बन्द गर्नुहोस्",
          "Update": "अपडेट गर्नुहोस्",
          "Add Firm": "फर्म थप्नुहोस्",
          "Type of Firm": "फर्मको प्रकार",
          "Contact Person": "सम्पर्क व्यक्ति",
          "Position": "पद",
          "Photo": "फोटो",
          "Stamp": "स्ट्याम्प",
          "NADA Document": "NADA कागजात",
          "Phone number owner's proof.": "फोन नम्बर मालिकको प्रमाण।",
          "Update Contact Person Passport Photo": "प्रोफाइल तस्वीर अपलोड गर्नुहोस्",
          "Province": "प्रदेश",
          "District": "जिल्ला",
          "City": "सहर",
          "Address": "ठेगाना",
          "Firm Latitude": "फर्मको अक्षांश",
          "Firm Longitude": "फर्मको देशान्तर",
          "Receipts": "रसिदहरू",
          "Attendance": "उपस्थिति",
          "Payment Due": "भुक्तानी बाँकी",
          "Upload Stamp of firm": "टिकटको तस्वीर अपलोड गर्नुहोस्",
          "Upload Suporting Document": "NADA कागजात अपलोड गर्नुहोस्",
          "Upload Another Suporting Document": "स्क्रिनसट अपलोड गर्नुहोस्",
          "Set Current Location": "हालको स्थान सेट गर्नुहोस्",
          "Drop A File": "एउटा फाइल छोड्नुहोस्",
          "Name is required": "नाम आवश्यक छ",
          "Pan Number is required": "प्यान नम्बर आवश्यक छ",
          "Position is required": "पद आवश्यक छ",
          "Address is required": "ठेगाना आवश्यक छ",
          "Passport Size Photo is required": "पासपोर्ट साइज फोटो आवश्यक छ",
          "Stamp Image is required": "छापको छवि आवश्यक छ",
           "Contact Person is required": "सम्पर्क व्यक्ति आवश्यक छ",
          "Phone Number is required": "गलत नम्बर",
          "same as logged user?": "लग गरिएको प्रयोगकर्ता जस्तै?",
          "Edit Firm": "फर्म सम्पादन गर्नुहोस्",
          "View current Photo": "हालको फोटो हेर्नुहोस्",
          "Update Stamp of firm": "टिकटको तस्वीर अपलोड गर्नुहोस्",
          "View current Stamp": "हालको स्टाम्प हेर्नुहोस्",
          "Update Supporting Document": "NADA कागजात अपलोड गर्नुहोस्",
          "View current supporting document": "हालको सहायक कागजात हेर्नुहोस्",
          "Update Another Supporting Document": "स्क्रिनसट अपलोड गर्नुहोस्",
          "View current supporting document 2": "हालको सहायक कागजात २ हेर्नुहोस्",
          "Firm Notes": "फर्म टिप्पणीहरू",
          "Firm Status": "फर्म स्थिति",
          "Update Firm": "फर्म अद्यावधिक गर्नुहोस्",
          "Current Passport Size Photo": "हालको पासपोर्ट आकारको फोटो",
  "Password": "पासवर्ड",
  "Update Profile": "प्रोफाइल अद्यावधिक गर्नुहोस्",
  "User Edit": "प्रयोगकर्ता सम्पादन",
  "Bulk Upload Firms": "फर्महरू थोकमा अपलोड गर्नुहोस्",
  "Upload CSV File": "CSV फाइल अपलोड गर्नुहोस्",
  "Upload": "अपलोड गर्नुहोस्",
  "Sign In To NADA Admin Portal": "NADA प्रशासक पोर्टलमा साइन इन गर्नुहोस्",
  "Welcome back! Log in to your account.": "फेरि स्वागत छ! आफ्नो खातामा लग इन गर्नुहोस्।",
  "Forgot Password": "पासवर्ड बिर्सनुभयो",
  "Sign In": "साइन इन गर्नुहोस्",
  "Don't have account ?": "खाता छैन?",
  "Create Account": "खाता सिर्जना गर्नुहोस्",
  "Create your account": "आफ्नो खाता सिर्जना गर्नुहोस्",
  "Already have an account?": "पहिले नै खाता छ?",
  "Continue": "जारी राख्नुहोस्",
  "OTP Code": "OTP कोड",
  "Enter 4-digit code": "४-अंकको कोड प्रविष्ट गर्नुहोस्",
  "Enter your phone number to start": "सुरु गर्न आफ्नो फोन नम्बर प्रविष्ट गर्नुहोस्",
  "Set Proxy Date": "प्रोक्सी मिति सेट गर्नुहोस्",
  "Start Date & Time": "सुरुवात मिति र समय",
  "End Date & Time": "अन्त्य मिति र समय",
  "Set Membership Fees": "सदस्यता शुल्क सेट गर्नुहोस्",
  "New Membership Price": "नयाँ सदस्यता मूल्य",
  "Renewal Membership Price": "नवीकरण सदस्यता मूल्य",
  "Set renew membership price": "नवीकरण सदस्यता मूल्य सेट गर्नुहोस्",
  "Set new membership price": "नयाँ सदस्यता मूल्य सेट गर्नुहोस्",
  "Verification": "सत्यापन",
  "Verify Document": "कागजात सत्यापन गर्नुहोस्",
  "Please scan the qr. If the doc is verified, it will be opened in new tab.": "कृपया QR स्क्यान गर्नुहोस्। यदि कागजात सत्यापित भएको छ भने, यसलाई नयाँ ट्याबमा खोलिनेछ।",
  "To Scan another qr, please refresh the page": "अर्को QR स्क्यान गर्न, कृपया पृष्ठलाई रिफ्रेश गर्नुहोस्।",
  "Payment Type": "भुक्तानी प्रकार",
  "Membership Status": "वार्षिक सदस्यता शुल्क",
  "Payment proof": "भुक्तानी प्रमाण",
  "No Payment proof found": "कुनै भुक्तानी प्रमाण फेला परेन",
  "Proxy Status": "प्रोक्सी स्थिति"
        },
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
